import useGlobalState from '@components/Hooks/useGlobalState';
import Success from '@Shared/Success';
import React from 'react';

const ContactAdminSuccess: React.FC = () => {

  const [store,] = useGlobalState();

  return (store.requested && !store.requested.message) ? (
    <Success>
      <h2>Message Sent</h2>
      <p>Administrators have been notified of your request and should be contacting you shortly.</p>
    </Success>
  ) : null;
}

export default ContactAdminSuccess;